export type WeightUnit = 'lb' | 'kg';

export const KG_PER_LB = 0.45359237;

export function kgToLb(kg: number): number {
  return kg / KG_PER_LB;
}

export function lbToKg(lb: number): number {
  return lb * KG_PER_LB;
}

export function toDisplayWeight(kg: number, unit: WeightUnit): number {
  const v = unit === 'lb' ? kgToLb(kg) : kg;
  return Math.round(v * 10) / 10;
}

export function fromDisplayWeight(value: number, unit: WeightUnit): number {
  return unit === 'lb' ? lbToKg(value) : value;
}

export function formatWeight(kg: number, unit: WeightUnit, opts: { signed?: boolean; decimals?: number } = {}): string {
  const decimals = opts.decimals ?? 1;
  const v = unit === 'lb' ? kgToLb(kg) : kg;
  const rounded = Number(v.toFixed(decimals));
  const sign = opts.signed && rounded > 0 ? '+' : opts.signed && rounded < 0 ? '−' : '';
  return `${sign}${Math.abs(rounded).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })} ${unit}`;
}

export function cmToFtIn(cm: number): { ft: number; inch: number } {
  const totalIn = cm / 2.54;
  let ft = Math.floor(totalIn / 12);
  let inch = Math.round(totalIn - ft * 12);
  if (inch === 12) {
    ft += 1;
    inch = 0;
  }
  return { ft, inch };
}

export function ftInToCm(ft: number, inch: number): number {
  return (ft * 12 + inch) * 2.54;
}
